// Custom plugin to draw rotated analytics Y2 axis title
export const flipY2TitlePlugin = {
    afterDraw: (chart, args, options) => {
        if (!options || !options.text) {
            return;
        }

        const { ctx, scales } = chart;
        const y2 = scales.y2;

        if (!y2) {
            return;
        }

        ctx.save();

        const titleFont = y2.options?.title?.font || {};
        const fontSize = titleFont.size || 16;
        const fontFamily = titleFont.family || 'Roboto, sans-serif';
        const fontStyle = titleFont.style || 'normal';
        const fontWeight = titleFont.weight || 'normal';

        ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        ctx.fillStyle = y2.options?.title?.color || y2.options?.ticks?.color || '#666';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const xPos = y2.right - 10;
        const yPos = y2.top + (y2.bottom - y2.top) / 2;

        ctx.translate(xPos, yPos);
        ctx.rotate(-Math.PI / 2);

        ctx.fillText(options.text, 0, 0);
        ctx.restore();
    },
    id: 'flipY2Title',
};
